import { render } from "./TheMbDivisionCountRadio.vue?vue&type=template&id=21dc416e"
import script from "./TheMbDivisionCountRadio.vue?vue&type=script&lang=js"
export * from "./TheMbDivisionCountRadio.vue?vue&type=script&lang=js"

import "./TheMbDivisionCountRadio.vue?vue&type=style&index=0&id=21dc416e&lang=scss"
script.render = render

export default script